import axios from 'axios'
import localData from '@/utility/localData'
const MarginalStore = {
data:{
   
    },

methods:
    {
      async delete(id){
        const token=localData.methods.getLocalToken()
        let parms = 'marginalCostOfReplacedEnergyRecords/' + id
        return await axios.delete(parms,{ headers: {"Authorization" : `Bearer ${token}`} }
        ).then(response=>{
           return response
        }).catch(error=>{
         console.log('Error: ', error)
        });
      },
        doPublish(id,published){
          const token=localData.methods.getLocalToken()
          let parms = 'marginalCostOfReplacedEnergyRecords/' + id
          return axios.patch(parms,{
            isPublished : published
          },{ headers: {"Authorization" : `Bearer ${token}`} }
          ).then(response=>{
              return response.data
          });

        },
        
        async addMarginalCostReplaced(title,year){
          const token=localData.methods.getLocalToken()
          return await axios.post('marginalCostOfReplacedEnergyRecords',{
            title : title,
            year: year,
          },{ headers: {"Authorization" : `Bearer ${token}`} }
          ).then(response=>{
              return response.data
          }).catch(error=>{
            console.log('Error: ', error)
          });
        },

      async addmarginalCostOfReplacedEnergyRecords(payload){
        let formData = new FormData();
            formData.append('title', payload.title)
            formData.append('year', payload.year)
            formData.append('csvFile', payload.csvFile)
        const token=localData.methods.getLocalToken()
        return await axios.post('marginalCostOfReplacedEnergyRecords',formData,
        {
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        }
        ).then(response=>{
            return response.data
        }).catch(error=>{
          console.log('Error: ', error)
        });
      },
      
      async edit(id,data){
        const payload = new FormData();
        Object.keys(data).forEach(key => payload.append(key, data[key]));
        const token = localData.methods.getLocalToken()
        return axios.patch('marginalCostOfReplacedEnergyRecords/' + id,payload,{headers: {
            "Authorization": `Bearer ${token}`
        }}).then((res=>{
            return res.data
        }));
      }
    },   
     
}
export default MarginalStore;